<template>
	<ProcessCreatePage>
		<Header :title="$t('new_damage_case_accident_data').toString()">
			<p>
				{{ $t('required_data_red_stars') }}
			</p>
		</Header>

		<div class="main">
			<accident-data-form ref="accident-data-form" @updateValue="updateValue" />
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick($event)"
			:disable-continue="isDataIncomplete"
			:is-skippable="false"
		/>
	</ProcessCreatePage>
</template>

<script>
import AccidentDataForm from '../forms/AccidentDataForm';
import Header from '@/components/damagecases/Header';
import Footer from '@/components/damagecases/Footer';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'Accident',
	components: { ProcessCreatePage, Footer, Header, AccidentDataForm },
	data() {
		return {
			accidentData: {},
			isDataIncomplete: true,
		};
	},
	methods: {
		checkNullOrEmpty(value) {
			return value == null || value === '';
		},
		updateValue: function($event) {
			this.accidentData = $event;
			this.checkDataComplete();
		},
		checkDataComplete() {
			this.isDataIncomplete = !!(
				this.checkNullOrEmpty(this.accidentData.isRecordedByPolice) ||
				this.checkNullOrEmpty(this.accidentData.date) ||
				this.checkNullOrEmpty(this.accidentData.accidentLocation) ||
				this.checkNullOrEmpty(this.accidentData.isPersonInjured)
			);
		},
		continueButtonClick: function($event) {
			if (this.$refs['accident-data-form'].validate()) {
				this.$emit('next', this.accidentData);
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
};
</script>

<style scoped></style>
